import { SymbolEvent } from 'widgets/corpActions/data/SymbolEvent';
import { SymbolEventColumn } from 'widgets/corpActions/widget/grid/columnDefinitions';
import { CorporateActionType } from 'widgets/corpActions/data/CorporateActionType';

import all from './all';
import idChange from './idChange';
import equityOffering from './equiityOffering';
import stockSplit from './stockSplit';
import listingChange from './listingChange';
import nameChange from './nameChange';
import rlotChange from './rlotChange';
import tickerChange from './tickerChange';
import delisting from './delisting';
import cashDividend from './cashDividend';
import stockDividend from './stockDividend';
import newListing from './newListing';
import rightsOffer from './rightsOffer';
import spin from './spin';
import earningsRelease from './earningsRelease';
import { notes } from 'widgets/corpActions/widget/details/sections/notes';
import { GridDetailsPanelColumnDef } from 'utils/components/GridDetailsPanel/gridDetailsPanelColumnDef';
import acquisition from './acquisition';
import bankruptcyFiling from 'widgets/corpActions/widget/details/sections/bankruptcyFiling';
import domicileChange from 'widgets/corpActions/widget/details/sections/domicileChange';
import currencyQuotation from 'widgets/corpActions/widget/details/sections/currencyQuotation';
import divestiture from 'widgets/corpActions/widget/details/sections/divestiture';
import partialPay from 'widgets/corpActions/widget/details/sections/partialPay';
import reclassification from 'widgets/corpActions/widget/details/sections/reclassification';
import shareholdersMeeting from 'widgets/corpActions/widget/details/sections/shareholdersMeeting';
import stockBuy from 'widgets/corpActions/widget/details/sections/stockBuy';
import { getSymbolEventTypeValue } from 'widgets/corpActions/api/SymbolEventsRequest';
import { CorpActionTypeHolidayEnum } from 'widgets/corpActions/data/HolidayType';
import holiday from 'widgets/corpActions/widget/details/sections/holidays';

const corpAtionsSectionsMap: Record<
    CorporateActionType,
    GridDetailsPanelColumnDef<SymbolEventColumn>[]
> = {
    [CorporateActionType.ACQUIS]: acquisition,
    [CorporateActionType.BANCR]: bankruptcyFiling,
    [CorporateActionType.CHG_DOM]: domicileChange,
    [CorporateActionType.CHG_ID]: idChange,
    [CorporateActionType.CHG_LIST]: listingChange,
    [CorporateActionType.CHG_NAME]: nameChange,
    [CorporateActionType.CHG_RLOT]: rlotChange,
    [CorporateActionType.CHG_TKR]: tickerChange,
    [CorporateActionType.CRNCY_QT_CHNG]: currencyQuotation,
    [CorporateActionType.DELIST]: delisting,
    [CorporateActionType.DIVEST]: divestiture,
    [CorporateActionType.DVD_CASH]: cashDividend,
    [CorporateActionType.DVD_STOCK]: stockDividend,
    [CorporateActionType.EQY_OFFER]: equityOffering,
    [CorporateActionType.LIST]: newListing,
    [CorporateActionType.PARTIAL_PAY]: partialPay,
    [CorporateActionType.RECLASS]: reclassification,
    [CorporateActionType.RIGHTS_OFFER]: rightsOffer,
    [CorporateActionType.SH_HOLDER_MEET]: shareholdersMeeting,
    [CorporateActionType.SPIN]: spin,
    [CorporateActionType.STOCK_BUY]: stockBuy,
    [CorporateActionType.STOCK_SPLT]: stockSplit,
    [CorporateActionType.EARN_RLS]: earningsRelease,
};

const holidaysSectionMap: Record<
    CorpActionTypeHolidayEnum,
    GridDetailsPanelColumnDef<SymbolEventColumn>[]
> = {
    [CorpActionTypeHolidayEnum.H]: holiday,
};

const typeSectionsMap: Record<
    string,
    GridDetailsPanelColumnDef<SymbolEventColumn>[]
> = { ...corpAtionsSectionsMap, ...holidaysSectionMap };

export function getPanelColumnDefs(
    corporateAction: SymbolEvent,
    withTitle = true
): GridDetailsPanelColumnDef<SymbolEventColumn>[] {
    const type = getSymbolEventTypeValue(corporateAction.type);

    const typeSpecificSections: GridDetailsPanelColumnDef<SymbolEventColumn>[] =
        typeSectionsMap[type] ?? [];

    return [
        ...all(corporateAction, withTitle),
        ...typeSpecificSections,
        ...notes,
    ];
}
